import { render, staticRenderFns } from "./Analytics2.vue?vue&type=template&id=0b427b9a&scoped=true&"
import script from "./Analytics2.vue?vue&type=script&lang=js&"
export * from "./Analytics2.vue?vue&type=script&lang=js&"
import style0 from "./Analytics2.vue?vue&type=style&index=0&id=0b427b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b427b9a",
  null
  
)

export default component.exports